export default {
  name: "ImagePreview",
  data: function data() {
    return {
      visible: false
    };
  },
  props: {
    imgs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    show: function show(index) {
      var _this = this;
      this.visible = true;
      setTimeout(function () {
        _this.$refs.carousel.setActiveItem(index);
      });
    }
  }
};